module.exports = __webpack_public_path__ + "static/media/avatar-6.49ea14c1.png";